import { createFileRoute } from '@tanstack/react-router'
import { useState, useMemo } from 'react'
import { Container } from '../../components/ui/Container'
import { ArticlesHero } from '../../components/features/articles/ArticlesHero'
import { ArticlesGrid } from '../../components/features/articles/ArticlesGrid'
import { getAllPosts } from '../../lib/data/posts'

export const Route = createFileRoute('/artikel/')({
  component: ArtikelList,
  loader: async () => {
    const { posts } = getAllPosts({ limit: 50 })
    return { initialArticles: posts }
  },
})

function ArtikelList() {
  const { initialArticles } = Route.useLoaderData()
  const [searchTerm, setSearchTerm] = useState('')

  const filteredArticles = useMemo(() => {
    if (!searchTerm) return initialArticles
    const term = searchTerm.toLowerCase()
    return initialArticles.filter(
      (article: any) =>
        article.title.toLowerCase().includes(term) ||
        (article.excerpt && article.excerpt.toLowerCase().includes(term))
    )
  }, [initialArticles, searchTerm])

  return (
    <div className="min-h-screen bg-brand-slate-50">
      <ArticlesHero
        searchTerm={searchTerm}
        onSearchChange={setSearchTerm}
      />

      <Container className="py-12 max-w-7xl mx-auto">
        <ArticlesGrid
          articles={filteredArticles}
          searchTerm={searchTerm}
        />
      </Container>
    </div>
  )
}
